export {default as default} from './HowItem'
